module.exports = __webpack_public_path__ + "img/business_1.67346c6f.png";